import setGlobalState from '../redux/setGlobalState';

export const wrapXHR = async (
    xhrKey: string,
    operation:() => Promise<any>
): Promise<any> => {
    setGlobalState(xhrKey, 'LOADING');
    try {
        const result = await operation();
        setGlobalState(xhrKey, 'SUCCESS');
        return result;
    } catch (error) {
        setGlobalState(xhrKey, 'FAILED');
        throw error;
    }
};

